import React, { useState } from "react";
import { IoLocation } from "react-icons/io5";
import AddressAutocomplete from "../../../utils/components/AddressAutocomplete";
import { AuthServices } from "../services/AuthServices";
import useUpdateOnboardingStatus from "../../../utils/hooks/useUpdateOnboardingStatus";

const Address = ({ setStep }) => {
  const [address, setAddress] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const updateOnboardingStatus = useUpdateOnboardingStatus();

  const handleSubmit = async () => {
    const response = await AuthServices.saveAddress(address);
    if (!response.success) {
      setErrorMessage(
        "There was an error updating your address. If the problem consists please contact support.",
      );
      return;
    }

    const statusUpdated = await updateOnboardingStatus("address");
    if (!statusUpdated) {
      setErrorMessage(
        "There was an error updating your address. If the problem consists please contact support.",
      );
      console.log("Failed to update onboarding status");
      return;
    }

    setStep(3);
  };

  return (
    <div className="address-container">
      <IoLocation className="address-icon" />
      <h2>Business Address</h2>
      <p>Where are you located</p>
      <div className="address-search-container">
        <IoLocation />
        <AddressAutocomplete onSelect={(data) => setAddress(data)} />
      </div>
      <button onClick={handleSubmit}>Continue</button>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
};

export default Address;
